import { render, staticRenderFns } from "./nekoReborn.vue?vue&type=template&id=464e2f8e&scoped=true"
import script from "./nekoReborn.vue?vue&type=script&lang=js"
export * from "./nekoReborn.vue?vue&type=script&lang=js"
import style0 from "./nekoReborn.vue?vue&type=style&index=0&id=464e2f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e2f8e",
  null
  
)

export default component.exports